import Insight from "../insightClass";
import React from "react";
import { insight83Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight083 = new Insight(
  "10 December 2025",
  {
    pageTitle: "Celebrating 25 Years of UK Offshore Wind",
    metaDescription:
      "WeBridge Insights, Celebrating 25 Years of UK Offshore Wind",
    keyWords:
      "European Offshore Wind Market development, Celebrating 25 Years of UK Offshore Wind",
  },
  {
    src: insight83Media[0],
    alt: "special celebrating poster",
  },
  "Celebrating 25 Years of UK Offshore Wind",
  "",
  `This week marks a significant milestone for our industry: 25 years since the UK installed its first offshore wind turbines at Blyth in 2000. From two pioneering 2 MW machines to today's multi-gigawatt build-outs, the UK has become a global offshore wind powerhouse—and a continued source of inspiration for emerging markets worldwide.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Celebrating 25 Years of UK Offshore Wind</h1>
    <h2></h2>
    <p className="article-date">10 December 2025</p>
    <img src={insight83Media[0]} alt="celebrating poster" />
    <br />
    <br />
    <br />
    <p>
      <b>– A Journey of Innovation, Scale, and Global Leadership</b>
    </p>
    <br />
    <p>
      This week marks a significant milestone for our industry:{" "}
      <b>
        25 years since the UK installed its first offshore wind turbines at
        Blyth in 2000.
      </b>
    </p>
    <p>
      From two pioneering 2 MW machines to today's multi-gigawatt build-outs,
      the UK has become a global offshore wind powerhouse—and a continued source
      of inspiration for emerging markets worldwide.
    </p>
    <p>
      At <b>WeBridge</b>, we're proud to work alongside developers, fabricators,
      vessel owners, and supply-chain partners who have helped shape this
      remarkable journey.
    </p>
    <p>
      <b>Key Milestones in the UK Offshore Wind Story</b>
    </p>
    <p>
      <b>2000 – Blyth Offshore Demonstrator</b>
    </p>
    <p>
      The UK's first offshore wind farm comes online, proving that offshore wind
      can work—and opening the door for large-scale deployment.
    </p>
    <p>
      <b>2003–2008 – Round 1 & Round 2 Projects</b>
    </p>
    <p>
      Early commercial wind farms such as North Hoyle, Scroby Sands, and Thanet
      build industry confidence, strengthen contractors' capabilities, and drive
      investment into coastal regions.
    </p>
    <p>
      <b>2010 – Round 3 Awards</b>
    </p>
    <p>
      The UK commits to the world's largest offshore wind development zones,
      including Dogger Bank, Hornsea, and East Anglia—setting the stage for
      global record-breaking projects.
    </p>
    <p>
      <b>2015–2020 – Industrialisation & Scale</b>
    </p>
    <p>
      The sector matures with &gt;6–8 MW turbines, new blade and tower
      factories, dedicated offshore wind ports, and major innovations in
      installation and logistics. Hornsea and Beatrice demonstrate true multi-GW
      project delivery.
    </p>
    <p>
      <b>2022–2024 – Lowest-Cost Renewable Power</b>
    </p>
    <p>
      Contracts for Difference (CfD) auctions showcase unprecedented cost
      reductions. Offshore wind becomes one of the cheapest sources of
      electricity in the UK—redefining the energy market.
    </p>
    <p>
      <b>2025 and Beyond</b>
    </p>
    <p>The next frontier includes:</p>
    <ul className="list-disc list-inside mb-8">
      <li>15–20 MW turbines</li>
      <li>Deep water offshore wind jackets and floating foundations</li>
      <li>Digitalised fabrication and next-generation marine logistics</li>
      <li>Stronger UK–global supply-chain partnerships</li>
      <li>Local content and sustainability as core project drivers</li>
    </ul>
    <p>
      At WeBridge, we believe the next 25 years will be defined not just by
      scale, but by{" "}
      <b>
        collaboration, supply-chain innovation, and smarter project execution
      </b>
      .
    </p>
    <p>
      We look forward to continuing our work supporting developers and
      manufacturers as the UK leads the way into the deep water wind era and a
      net-zero energy system.
    </p>
    <p>
      Here's to the next chapter and the next 25 years of offshore wind
      excellence.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
